export default __webpack_public_path__ + "static/gt-d15a032ec515a61d320ca71b1548a8a5.svg";